
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { ElMessage } from "element-plus";

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("吃菜/做菜统计目录", ["系统设置"]);
    });

    const store = useStore();
    const selectedCategories = ref<number[]>([]);
    const categories = ref<Array<{ id: number; name: string }>>([]);
    const saving = ref(false);

    store.dispatch(Actions.GET_BOX_CATEGORIES).then(() => {
      categories.value = store.getters.currentBoxCategories;
    }).catch((e: unknown) => console.error(e));

    store.dispatch(Actions.GET_SYSTEM_SETTING, "eat_cook_category_ids").then(() => {
      const setting = store.getters.currentSystemSetting;
      if (setting && setting.value) {
        try {
          selectedCategories.value = setting.value.split(",").map((s: string) => s.trim()).filter((s: string) => s !== "").map((s: string) => Number(s));
        } catch (e) { console.error(e); }
      }
    }).catch((e: unknown) => console.error(e));

    const onSave = () => {
      saving.value = true;
      store.dispatch(Actions.UPDATE_SYSTEM_SETTING, {
        system_setting: { key: "eat_cook_category_ids", title: "吃菜/做菜统计目录", value: selectedCategories.value.join(",") }
      }).then(() => ElMessage.success("保存成功"))
        .catch(() => ElMessage.error("保存失败"))
        .finally(() => { saving.value = false; });
    };

    return { selectedCategories, categories, saving, onSave };
  },
});
